module.exports = __webpack_public_path__ + "img/studio.0e5c194a.jpg";